// vue-wrapper.js
import React, { useRef, useEffect } from 'react'
import { createApp } from 'vue'
import { createStore } from 'vuex'
import { createRouter, createWebHistory } from 'vue-router'

// Create a wrapper component for Vue
export function createVueWrapper(Component, props = {}) {
  return function VueWrapper({ ...reactProps }) {
    const containerRef = useRef(null)
    const appRef = useRef(null)

    useEffect(() => {
      if (containerRef.current) {
        // Create Vue app
        const app = createApp(Component, { ...props, ...reactProps })
        
        // Add Vuex store
        const store = createStore({
          // Your store configuration
        })
        app.use(store)
        
        // Add Vue Router if needed
        const router = createRouter({
          history: createWebHistory(),
          routes: [
            // Your routes
          ]
        })
        app.use(router)
        
        // Mount Vue app
        app.mount(containerRef.current)
        appRef.current = app
      }

      return () => {
        if (appRef.current) {
          appRef.current.unmount()
        }
      }
    }, [])

    return <div ref={containerRef} />
  }
}